import {
  SovendusStoreConfig,
  SovendusVariantConfig,
} from '@moonpig/web-core-types'

export const createSovendusConfig = (
  id: string,
): SovendusStoreConfig | undefined => {
  const parsed = parseSovendusEnv(process.env.SOVENDUS)
  if (!parsed) return undefined

  const embedded = readVariant(parsed.embedded?.[id])

  if (!embedded) return undefined

  return { embedded }
}

type SovendusEnvShape = {
  embedded?: Record<string, Partial<SovendusVariantConfig> | undefined>
}

const parseSovendusEnv = (
  raw: string | undefined,
): SovendusEnvShape | undefined => {
  if (!raw) return undefined
  try {
    const parsed = JSON.parse(raw)
    if (parsed && typeof parsed === 'object') return parsed as SovendusEnvShape
  } catch (e) {
    // fall through
  }
  return undefined
}

const readVariant = (
  raw: Partial<SovendusVariantConfig> | undefined,
): SovendusVariantConfig | undefined => {
  const trafficSourceNumber = raw?.trafficSourceNumber?.trim()
  const trafficMediumNumber = raw?.trafficMediumNumber?.trim()
  if (!trafficSourceNumber || !trafficMediumNumber) return undefined
  return { trafficSourceNumber, trafficMediumNumber }
}
